import React, { useEffect } from "react";
import { Form, DatePicker, Input, Select, Button, message } from "antd";
import { useDispatch, useSelector } from "react-redux";
import AdminDashLayout from "../../../../Components/Admin/AdminDashLayout";
import { scheduleInterviewThunk } from "../../../../Store/Slices/Admin/jobApplication/jobApplicationThunks";
import { useNavigate, useParams } from "react-router-dom";
import { fetchAllStaff } from "../../../../Store/Slices/Admin/Users/Staff/staff.action";

const { Option } = Select;

const ScheduleInterviewMain = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const { applicationId, roundId ,jobId} = useParams();

  const [form] = Form.useForm();

  const mode = Form.useWatch("mode", form); 

  const { staff } = useSelector((store) => store.admin.all_staff);

  useEffect(() => {
    if (!staff?.length) {
      dispatch(fetchAllStaff());
    }
  }, [dispatch, staff]);

  const handleSubmit = async (values) => {
    try {
      const payload = {
        scheduledAt: values.scheduledAt.toISOString(),
        durationMinutes: values.durationMinutes,
        mode: values.mode,
        meetingLink: values.meetingLink,
        location: values.location,
        assignedStaff: values.assignedStaff,
      };

      await dispatch(
        scheduleInterviewThunk({
          applicationId,
          roundId,
          interviewData: payload,
        })
      ).unwrap();

      message.success("Interview scheduled successfully");
      navigate(`/careers/applications/${jobId}`)
    } catch (error) {
      console.log(error);

      message.error(error || "Failed to schedule interview");
    }
  };

  return (
    <AdminDashLayout>
      <div className="p-6">
        <h1 className="mb-6 font-bold text-2xl">Schedule Interview</h1>

        <Form layout="vertical" form={form} onFinish={handleSubmit}>
          {/* Date */}
          <Form.Item
            label="Interview Date & Time"
            name="scheduledAt"
            rules={[{ required: true, message: "Please select date & time" }]}
          >
            <DatePicker showTime style={{ width: "100%" }} />
          </Form.Item>

          {/* Duration */}
          <Form.Item
            label="Duration (minutes)"
            name="durationMinutes"
            rules={[{ required: true }]}
          >
            <Input type="number" />
          </Form.Item>

         
          <Form.Item label="Mode" name="mode" rules={[{ required: true }]}>
            <Select placeholder="Select mode">
              <Option value="online">Online</Option>
              <Option value="offline">Offline</Option>
            </Select>
          </Form.Item>

         
          {mode === "online" && (
            <Form.Item
              label="Meeting Link"
              name="meetingLink"
              rules={[{ required: true, message: "Please enter meeting link" }]}
            >
              <Input placeholder="https://meet.google.com/..." />
            </Form.Item>
          )}

         
          <Form.Item label="Location" name="location">
            <Input placeholder="Interview location" />
          </Form.Item>

         
          <Form.Item
            label="Assign Staff"
            name="assignedStaff"
            rules={[{ required: true, message: "Please select staff" }]}
          >
            <Select
              placeholder="Select interviewer"
              showSearch
              optionFilterProp="label"
              options={staff?.map((s) => ({
                value: s._id,
                label: `${s.firstName} ${s.lastName}`,
              }))}
            />
          </Form.Item>

          <Button type="primary" htmlType="submit" className="btn-gradient">
            Schedule Interview
          </Button>
        </Form>
      </div>
    </AdminDashLayout>
  );
};

export default ScheduleInterviewMain;

